export type BookingFlowStepId =
    | "lab"
    | "consultation"
    | "clinic"
    | "form"
    | "pay"
    | "confirmation";

export const BOOKING_FLOW_STEP_ORDER: BookingFlowStepId[] = [
    "lab",
    "clinic",
    "form",
    "consultation",
    "pay",
    "confirmation",
];

/** Private (24h) lab skips consultation — follow-up is always express online. */
export const getBookingFlowStepOrder = (
    skipConsultationStep: boolean
): BookingFlowStepId[] =>
    skipConsultationStep
        ? BOOKING_FLOW_STEP_ORDER.filter((stepId) => stepId !== "consultation")
        : BOOKING_FLOW_STEP_ORDER;
